import axios from 'axios';
import { csvParse } from 'd3';
import { parseString } from 'xml2js';

const ExportService = {
  get: async function (url) {
    const requestData = {
      method: "get",
      url: url,
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = error.response.data.error;
      throw new Error(message);
    }
  },
  getDataflowB: async function (year, tz, description) {
    return await this.get('/dataflows/b?year=' + year + '&tz=' + tz + '&description=' + description);
  },
  getDataflowC: async function (year, tz, description) {
    return await this.get('/dataflows/c?year=' + year + '&tz=' + tz + '&description=' + description);
  },
  getDataflowG: async function (year, tz, description) {
    return await this.get('/dataflows/g?year=' + year + '&tz=' + tz + '&description=' + description);
  },
  getDataflowD: async function (year, tz, description) {
    return await this.get('/dataflows/d?year=' + year + '&tz=' + tz + '&description=' + description);
  },
  getDataFlowE1A: async function (year, tz, description) {
    return await this.get('/dataflows/e1a?year=' + year + '&tz=' + tz + '&description=' + description);
  }
};

export default ExportService;

export { ExportService };
